var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.5C4 4.11929 5.11929 3 6.5 3H12.2322C12.8953 3 13.5312 3.26339 14 3.73223L18.2678 8C18.7366 8.46884 19 9.10473 19 9.76777V20.5C19 21.8807 17.8807 23 16.5 23H6.5C5.11929 23 4 21.8807 4 20.5V5.5ZM6.5 13C6.5 12.3096 7.05964 11.75 7.75 11.75H15.25C15.9404 11.75 16.5 12.3096 16.5 13C16.5 13.6904 15.9404 14.25 15.25 14.25H7.75C7.05964 14.25 6.5 13.6904 6.5 13ZM7.75 16.75C7.05964 16.75 6.5 17.3096 6.5 18C6.5 18.6904 7.05964 19.25 7.75 19.25H15.25C15.9404 19.25 16.5 18.6904 16.5 18C16.5 17.3096 15.9404 16.75 15.25 16.75H7.75Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.8ca2a955e41723ffb834c146ada5c6d4.svg";
export { ForwardRef as ReactComponent };